export function capitalizeFirstLetter(text: string) {
	return text
		.split("_")
		.map((v) => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase())
		.join(" ");
}

export function showReadableText(str: string) {
	return str.replace(/_/g, " ");
}

export function getWebUrl() {
	const host = process.env.REACT_APP_STAGE === "development" ? "http://" : "https://";
	return `${host}${process.env.REACT_APP_WEBSITE_URL}`;
}

export function copyToClipboard(text: string) {
	let textarea;
	let result;

	try {
		textarea = document.createElement("textarea");
		textarea.setAttribute("readonly", "true");
		textarea.setAttribute("contenteditable", "true");
		textarea.style.position = "fixed"; // prevent scroll from jumping to the bottom when focus is set.
		textarea.value = text;

		document.body.appendChild(textarea);

		textarea.focus();
		textarea.select();

		const range = document.createRange();
		range.selectNodeContents(textarea);

		const sel = window.getSelection();
		sel?.removeAllRanges();
		sel?.addRange(range);

		textarea.setSelectionRange(0, textarea.value.length);
		result = document.execCommand("copy");
	} catch (err) {
		console.error(err);
		result = null;
	} finally {
		document.body.removeChild(textarea as any);
	}

	// manual copy fallback using prompt
	if (!result) {
		const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
		const copyHotkey = isMac ? "⌘C" : "CTRL+C";
		result = prompt(`Press ${copyHotkey}`, text); // eslint-disable-line no-alert
		if (!result) {
			return false;
		}
	}
	return true;
}

export function maskEmail(email: string) {
	const [localPart, domain] = email.split("@");
	const [domainName, domainExt] = domain.split(".");

	const maskedLocal = localPart[0] + "***";
	const maskedDomainName = "***";
	const maskedDomainExt = domainExt[0] + "**";

	return `${maskedLocal}@${maskedDomainName}.${maskedDomainExt}`;
}

export function generateFullName(params: { firstName?: string; middleName?: string; lastName?: string }) {
	let list = [params.firstName, params.middleName, params.lastName];
	list = list.filter((item) => item);
	return list.join(" ");
}
